import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { ArrowRight, Megaphone } from "lucide-react";
import { BANNER_ROUTES, bannerResponseSchema } from "@nh/shared";
import { apiFetch } from "@/shared/api/client";

/**
 * La franja de anuncio sobre la tienda — la administra el panel
 * (`admin/banner`). Apagada o vacía, este componente no pinta NADA:
 * ni un hueco, ni un parpadeo (la consulta calla en `null` y el layout
 * no reserva espacio).
 */
export function AnnouncementBar() {
  const banner = useQuery({
    queryKey: ["banner"],
    queryFn: async () => {
      const data = await apiFetch(BANNER_ROUTES.public, bannerResponseSchema, { baseUrl: "" });
      return data.banner;
    },
    staleTime: 5 * 60 * 1000,
  });

  const settings = banner.data;
  if (!settings?.enabled || !settings.title.trim()) return null;

  const cta =
    settings.ctaLabel && settings.ctaTo ? (
      <Link
        to={settings.ctaTo}
        className="inline-flex items-center gap-1 font-semibold underline underline-offset-2 transition hover:opacity-80"
      >
        {settings.ctaLabel}
        <ArrowRight className="h-3.5 w-3.5" />
      </Link>
    ) : null;

  return (
    <div className="relative z-[60] flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-ds-violet-pop px-4 py-2 text-center text-[13px] text-white">
      <Megaphone className="h-4 w-4 shrink-0" />
      <span className="font-semibold">{settings.title}</span>
      {settings.message && <span className="text-white/85">{settings.message}</span>}
      {cta}
    </div>
  );
}
